import { render, staticRenderFns } from "./WorkLocationTab.vue?vue&type=template&id=7d4c4ba4&scoped=true"
import script from "./WorkLocationTab.vue?vue&type=script&lang=js"
export * from "./WorkLocationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c4ba4",
  null
  
)

export default component.exports